
import { Component, Vue, Prop } from 'vue-property-decorator'
import type { SharePopupParams } from './index.vue'
import { handleFill } from '@/utils/util'

@Component
class ActivityShareCard extends Vue {
  @Prop({ required: true }) data!: SharePopupParams
  handleFill = handleFill

  /** 只取第一张图，没有图片时使用默认图 */
  get displayImage (): string {
    // 默认使用 default-img2.png（活动分享卡片专用图）
    const defaultImg = require('@/assets/images/wordChain/default-img2.png')
    if (!this.data.images || this.data.images.length === 0) {
      return defaultImg
    }
    return this.data.images[0]
  }
}

export default ActivityShareCard
